import { render, staticRenderFns } from "./FlowView.vue?vue&type=template&id=4711b054"
import script from "./FlowView.vue?vue&type=script&lang=js"
export * from "./FlowView.vue?vue&type=script&lang=js"
import style0 from "./FlowView.vue?vue&type=style&index=0&id=4711b054&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports